import { Link } from 'react-router'

export default function NotFoundPage() {
  return (
    <main className="bg-stock mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-6">
      <p className="eyebrow mb-3">No such page</p>
      <h1 className="font-display text-ink mb-6 text-[2rem] leading-none">OFF THE FIELD</h1>
      <Link to="/pools" className="text-mark text-body underline underline-offset-4">
        Back to your pools
      </Link>
    </main>
  )
}
